import FormatDuration from 'format-duration';

export const formatDuration = (durationInSeconds) => {
  const durationInMilliseconds = durationInSeconds * 1000;
  return FormatDuration(durationInMilliseconds);
};
